export default __webpack_public_path__ + "static/media/reviews.3e2b58c6.jpg";